import React from 'react';

import { MCButton, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { lang, permissions, withRouter } from 'src/helpers';

import model from './model';

class Invoices extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }
  save = (e) => {
    e.preventDefault();
    model.save();
  };
  cancel = (e) => {
    e.preventDefault();
    model.reset();
  };

  handleChange = (n, v) => {
    model.setStateSilent({ changed: true });
    model.resetApiState('update');
    model.handleChange(n, v);
  };

  render = () => {
    const { invalid, loading, ...createState } = model.getApiState('update');

    return (
      <div className={'mc-main-content'}>
        <form
          className={'mc-setting-payment-detail mc-flex-0-col'}
          style={{ height: '100%' }}
          onSubmit={this.save}
        >
          <div className={'mc-header'}>
            <div className={'mc-title'}>
              {lang.t(permissions.PAGES.SETTINGS_INVOICES_PAGE.title)}
            </div>
          </div>
          <div className={'mc-form mc-grow mc-plr30 mc-flex-25-col'}>
            <div className={'mc-flex-20-col'}>
              <TextField
                template={6}
                label={'Serie'}
                name={'serie'}
                placeholder={''}
                value={model.input('serie')}
                onChange={this.handleChange}
                onBlur={model.handleBlur}
                invalid={invalid}
              />

              <TextField
                template={6}
                label={'Next number'}
                name={'nextNumber'}
                placeholder={''}
                value={model.input('nextNumber')}
                onChange={this.handleChange}
                onBlur={model.handleBlur}
                invalid={invalid}
              />
            </div>
            {(model.state.changed || !model.state.user?.invoice) && (
              <div className={'mc-b2t mc-flex mc-p30'}>
                {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
                <div className={'mc-grow'}></div>
                {!loading && (
                  <MCButton
                    onClick={this.cancel}
                    medium
                    primary
                    radius
                    light
                    label={lang.t('Cancel')}
                    disabled={loading}
                  />
                )}
                <MCButton
                  type={'submit'}
                  medium
                  primary
                  radius
                  dark
                  disabled={loading}
                  loading={loading}
                  label={'Save'}
                />
              </div>
            )}
          </div>
        </form>
      </div>
    );
  };
}

export default withRouter(Invoices);
